const obj = {
    //历史库存列表 表格信息
    stockHistoryList: [
        {
            fieldEntity:"bgmCode",
            fieldShow:"商品编码",
            fieldType:"string",//类型  dete：时间  string：字符串 number：数字
            fieldWeight:150,
            formatterContent:"",
            isShow:1,
            isTotal:0,//合计字段和fieldType中的number类型组合使用  isTotal:1 开启 0关闭
            sort:1,
            isSort:0,//排序字段和fieldType中的date,number类型组合使用 isSort：1开启 0关闭
        },
        {
            fieldEntity:"bgmName",
            fieldShow:"通用名称",
            fieldType:"string",
            fieldWeight:200,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"bgiGename",
            fieldShow:"商品名称",
            fieldType:"string",
            fieldWeight:150,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"coName",
            fieldShow:"货主名称",
            fieldType:"string",
            fieldWeight:150,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"opmName",
            fieldShow:"采购员",
            fieldType:"string",
            fieldWeight:150,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"bgiRegistno",
            fieldShow:"注册证号或备案凭证编号",
            fieldType:"string",
            fieldWeight:200,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"manufacturer",
            fieldShow:"生产商",
            fieldType:"string",
            fieldWeight:200,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"placeorigin",
            fieldShow:"产地",
            fieldType:"string",
            fieldWeight:110,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"spec",
            fieldShow:"规格",
            fieldType:"string",
            fieldWeight:150,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"bgpUnitmeasurement",
            fieldShow:"包装单位",
            fieldType:"string",
            fieldWeight:110,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"batchno",
            fieldShow:"批号",
            fieldType:"string",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"prodate",
            fieldShow:"生产日期",
            fieldType:"date",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"expidate",
            fieldShow:"失效日期",
            fieldType:"date",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"bgiPerholder",
            fieldShow:"上市许可人",
            fieldType:"string",
            fieldWeight:150,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"smName",
            fieldShow:"购进单位",
            fieldType:"string",
            fieldWeight:150,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:0,
        },
        {
            fieldEntity:"days",
            fieldShow:"在库天数",
            fieldType:"number",
            fieldWeight:150,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"createTime",
            fieldShow:"入库时间",
            fieldType:"date",
            fieldWeight:110,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"psprice",
            fieldShow:"采购单价",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:0,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"inItCount",
            fieldShow:"期初数量",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"inItMoney",
            fieldShow:"期初金额",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"inItPsMoney",
            fieldShow:"期初含税金额",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"inCount",
            fieldShow:"入库数量",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"inMoney",
            fieldShow:"入库金额",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"inPsMoney",
            fieldShow:"入库含税金额",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"outCount",
            fieldShow:"出库数量",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"outMoney",
            fieldShow:"出库金额",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"outPsMoney",
            fieldShow:"出库含税金额",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"endCount",
            fieldShow:"期末数量",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"endMoney",
            fieldShow:"期末金额",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        },
        {
            fieldEntity:"endPsMoney",
            fieldShow:"期末含税金额",
            fieldType:"number",
            fieldWeight:120,
            formatterContent:"",
            isShow:1,
            isTotal:1,
            sort:1,
            isSort:1,
        }
    ]
}
export default obj